// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio {
  --studio-bg: #100e13;
  --studio-panel: #19161d;
  --studio-line: #343039;
  --studio-muted: #b6adb9;
  --studio-pink: #efa2ca;
  --studio-violet: #bca9e8;
  background: var(--studio-bg);
  color: #f4eef3;
  min-height: 100vh;
  font-family: Inter, system-ui, sans-serif;
  line-height: 1.65;
}
.portfolio * {
  box-sizing: border-box;
}
.portfolio a {
  color: inherit;
  text-decoration: none;
}
.portfolio a:hover {
  color: var(--studio-pink);
}
.portfolio :focus-visible {
  outline: 2px solid var(--studio-pink);
  outline-offset: 5px;
}
.portfolio h1,
.portfolio h2,
.portfolio h3,
.portfolio p {
  margin-top: 0;
}
.portfolio h1,
.portfolio h2,
.portfolio h3 {
  line-height: 1.1;
  letter-spacing: -0.04em;
}
.portfolio p {
  color: var(--studio-muted);
}
.portfolio button {
  font: inherit;
  cursor: pointer;
}
.portfolio button:disabled {
  opacity: 0.5;
  cursor: wait;
}
.portfolio .studio-header {
  min-height: 108px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  padding: 24px 4.5%;
  border-bottom: 1px solid var(--studio-line);
  position: relative;
  z-index: 60;
  background: var(--studio-bg);
}
.portfolio .studio-brand {
  display: flex;
  align-items: center;
  gap: 13px;
  font-weight: 600;
  letter-spacing: 0.12em;
  font-size: 19px;
  line-height: 1.2;
}
.portfolio .studio-mark {
  font: italic 44px Georgia;
  color: var(--studio-pink);
  letter-spacing: -0.1em;
  padding-right: 7px;
}
.portfolio .studio-brand-sub {
  display: block;
  font-size: 8px;
  letter-spacing: 0.16em;
  color: var(--studio-muted);
  margin-top: 6px;
}
.portfolio .studio-nav {
  display: flex;
  gap: 25px;
  align-items: center;
  font-size: 13px;
}
.portfolio .studio-nav a {
  display: flex;
  align-items: center;
  position: relative;
}
.portfolio .studio-nav a.active {
  color: var(--studio-pink);
}
.portfolio .studio-nav a.active:after {
  content: "";
  position: absolute;
  bottom: 1px;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--studio-pink);
}
.portfolio .studio-menu {
  display: none;
}
.portfolio .studio-container {
  width: min(1240px, 91%);
  margin: auto;
}
.portfolio .studio-skip {
  position: absolute;
  top: -100px;
  left: 20px;
  background: #100e13;
  padding: 12px;
  z-index: 100;
}
.portfolio .studio-skip:focus {
  top: 8px;
}
.portfolio .studio-eyebrow {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-weight: 600;
  color: var(--studio-pink);
  margin-bottom: 24px;
}
.portfolio .studio-eyebrow span {
  color: #706575;
  margin: 0 8px;
}
.portfolio .studio-hero {
  padding: 96px 0 80px;
  position: relative;
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 55px;
  align-items: center;
}
.portfolio .studio-hero h1 {
  font-size: clamp(48px, 6.4vw, 92px);
  font-weight: 400;
  max-width: 850px;
  margin-bottom: 28px;
}
.portfolio .studio-hero h1 em {
  font-family: Georgia, serif;
  font-weight: 400;
  color: var(--studio-pink);
}
.portfolio .studio-hero-copy {
  font-size: 17px;
  max-width: 490px;
}
.portfolio .studio-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 32px;
}
.portfolio .studio-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 13px 24px;
  background: var(--studio-pink);
  color: #211220;
  border: 1px solid var(--studio-pink);
  font-size: 13px;
  font-weight: 600;
  border-radius: 3px;
}
.portfolio .studio-button:hover {
  background: #f7c2df;
  color: #211220;
}
.portfolio .studio-button.secondary {
  color: #eee3ef;
  background: transparent;
  border-color: #514553;
}
.portfolio .studio-hero-art {
  position: relative;
  min-height: 370px;
  display: grid;
  place-items: center;
  overflow: hidden;
  border: 1px solid var(--studio-line);
  border-radius: 180px 180px 4px 4px;
  background:
    radial-gradient(ellipse at 50% 35%, #56334f, transparent 65%), #17131c;
}
.portfolio .studio-hero-art:before,
.portfolio .studio-hero-art:after {
  content: "";
  position: absolute;
  border: 1px solid #97728b;
  border-radius: 50%;
  width: 245px;
  height: 245px;
  transform: rotate(-35deg) scaleX(0.6);
}
.portfolio .studio-hero-art:after {
  transform: rotate(35deg) scaleX(0.6);
  border-color: #bca9e8;
}
.portfolio .studio-art-star {
  font-size: 160px;
  color: #e3bdce;
  font-family: Georgia;
  line-height: 1;
  z-index: 1;
}
.portfolio .studio-art-caption {
  position: absolute;
  bottom: 28px;
  text-transform: uppercase;
  font-size: 9px;
  letter-spacing: 0.25em;
  color: #c6b6c9;
}
.portfolio .studio-section {
  padding: 58px 0 66px;
  border-top: 1px solid var(--studio-line);
}
.portfolio .studio-section-heading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 30px;
}
.portfolio .studio-section-heading h2 {
  font-size: clamp(28px, 3vw, 42px);
  font-weight: 400;
  margin: 0;
}
.portfolio .studio-text-link {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  font-size: 13px;
  color: var(--studio-pink);
  border-bottom: 1px solid #725469;
}
.portfolio .studio-intro {
  padding: 76px 0 54px;
  border-bottom: 1px solid var(--studio-line);
  margin-bottom: 40px;
}
.portfolio .studio-intro h1 {
  font-size: clamp(38px, 5vw, 70px);
  font-weight: 400;
  max-width: 900px;
  margin-bottom: 22px;
}
.portfolio .studio-lede {
  max-width: 650px;
  font-size: 18px;
}
.portfolio .studio-books {
  padding-bottom: 70px;
}
.portfolio .studio-book {
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  gap: 55px;
  align-items: center;
  padding: 42px 0;
  border-bottom: 1px solid var(--studio-line);
}
.portfolio .studio-book:first-child {
  padding-top: 0;
}
.portfolio .studio-book-art {
  background: linear-gradient(140deg, #2a202c, #18161f);
  min-height: 350px;
  padding: 30px;
  display: grid;
  place-items: center;
}
.portfolio .studio-book-art img {
  height: 320px;
  width: auto;
  max-width: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  box-shadow: 12px 15px 30px #0007;
}
.portfolio .studio-type-cover {
  min-height: 300px;
  width: min(230px, 100%);
  padding: 30px 25px;
  background: #e9daca;
  color: #30242e;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-left: 6px solid #c8b19e;
  box-shadow: 12px 15px 30px #0007;
}
.portfolio .studio-type-cover strong {
  font: 40px/1.05 Georgia;
  letter-spacing: -0.05em;
}
.portfolio .studio-type-cover span {
  font-size: 8px;
  letter-spacing: 0.14em;
}
.portfolio .studio-book-copy h2 {
  font-size: clamp(30px, 3.4vw, 45px);
  font-weight: 400;
}
.portfolio .studio-author {
  font-size: 12px;
}
.portfolio .studio-reader-link {
  display: block;
  font-size: 12px;
  margin-top: 18px;
  color: var(--studio-muted);
}
.portfolio .studio-project-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 28px;
  padding-bottom: 50px;
}
.portfolio .studio-project-card {
  background: var(--studio-panel);
  border: 1px solid var(--studio-line);
  overflow: hidden;
  border-radius: 5px;
}
.portfolio .studio-project-image {
  height: 250px;
  width: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  background: #211d27;
  padding: 20px;
}
.portfolio .studio-project-placeholder {
  height: 200px;
  display: grid;
  place-items: center;
  background: linear-gradient(140deg, #2f263a, #1b1920);
  color: var(--studio-violet);
  font-size: 55px;
  font-family: Georgia;
}
.portfolio .studio-project-copy {
  padding: 28px;
}
.portfolio .studio-project-copy h2 {
  font-size: 29px;
  margin: 15px 0;
}
.portfolio .studio-project-copy p {
  font-size: 14px;
}
.portfolio .studio-badge {
  display: inline-block;
  font-size: 10px;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--studio-violet);
  border: 1px solid #655373;
  padding: 4px 10px;
  border-radius: 20px;
}
.portfolio .studio-meta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  font-size: 12px;
  color: var(--studio-muted);
}
.portfolio .studio-filter {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin: 30px 0;
}
.portfolio label {
  font-size: 13px;
  display: block;
}
.portfolio input,
.portfolio select,
.portfolio textarea {
  background: #211b27;
  color: #f4eef3;
  border: 1px solid #65556c;
  border-radius: 4px;
  padding: 10px;
  max-width: 100%;
}
.portfolio .studio-filter select {
  display: block;
  min-width: 180px;
  margin-top: 8px;
}
.portfolio .studio-editor-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.portfolio .studio-editor-fields input,
.portfolio .studio-editor-fields select,
.portfolio .studio-editor-fields textarea {
  display: block;
  width: 100%;
  margin-top: 7px;
}
.portfolio .studio-field-wide {
  grid-column: 1/-1;
}
.portfolio .studio-rich-content {
  max-width: 850px;
  margin: 40px auto 70px;
  overflow-wrap: anywhere;
}
.portfolio .studio-rich-content h2 {
  font-size: 28px;
  line-height: 1.3;
}
.portfolio .studio-rich-content p {
  margin-bottom: 1.5em;
}
.portfolio .studio-rich-content a {
  text-decoration: underline;
  color: var(--studio-pink);
}
.portfolio .studio-gallery {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  margin: 30px 0;
}
.portfolio .studio-gallery img {
  max-height: 450px;
  -o-object-fit: contain;
     object-fit: contain;
}
.portfolio .studio-update {
  padding: 25px 0;
  border-top: 1px solid var(--studio-line);
}
.portfolio .studio-two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 45px;
}
.portfolio .studio-note {
  padding: 35px;
  background: var(--studio-panel);
  border: 1px solid var(--studio-line);
}
.portfolio .studio-note h2 {
  font-size: 30px;
  font-weight: 400;
}
.portfolio .studio-writing-link {
  display: flex;
  justify-content: space-between;
  gap: 25px;
  padding: 34px 0;
  border-bottom: 1px solid var(--studio-line);
}
.portfolio .studio-writing-link h2 {
  font-size: 36px;
  font-weight: 400;
  margin-bottom: 12px;
}
.portfolio .studio-writing-link span {
  font-size: 28px;
  color: var(--studio-pink);
}
.portfolio .studio-footer {
  padding: 65px 4.5% 25px;
  border-top: 1px solid var(--studio-line);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}
.portfolio .studio-footer-brand {
  display: flex;
  gap: 30px;
  font-size: 30px;
  letter-spacing: -0.04em;
  align-items: center;
}
.portfolio .studio-footer-brand span {
  color: var(--studio-pink);
}
.portfolio .studio-footer p {
  font-size: 12px;
}
.portfolio .studio-footer-links {
  display: flex;
  gap: 20px;
  align-items: start;
  justify-content: end;
  flex-wrap: wrap;
  font-size: 12px;
}
.portfolio .studio-colophon {
  grid-column: 1/-1;
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: #9b909f;
  border-top: 1px solid var(--studio-line);
  padding-top: 25px;
}
.portfolio .studio-music {
  padding-bottom: 70px;
}
.portfolio .studio-empty {
  padding: 40px 0;
}
.portfolio .studio-music-embed {
  border: 0;
  border-radius: 8px;
  width: 100%;
  height: 352px;
}
@media (max-width: 1050px) {
  .portfolio .studio-nav {
    gap: 15px;
    font-size: 12px;
  }
  .portfolio .studio-brand-sub {
    display: none;
  }
  .portfolio .studio-hero {
    gap: 25px;
  }
  .portfolio .studio-hero-art {
    min-height: 320px;
  }
}
@media (max-width: 800px) {
  .portfolio .studio-header {
    min-height: 85px;
    flex-wrap: wrap;
    padding: 20px 5%;
  }
  .portfolio .studio-menu {
    display: block;
    background: transparent;
    color: var(--studio-pink);
    border: 1px solid var(--studio-line);
    font-size: 12px;
  }
  .portfolio .studio-nav {
    display: none;
    flex-basis: 100%;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    padding: 12px 0;
  }
  .portfolio .studio-nav.is-open {
    display: flex;
  }
  .portfolio .studio-nav a {
    padding: 10px 0;
  }
  .portfolio .studio-nav a.active:after {
    display: none;
  }
  .portfolio .studio-hero {
    padding: 58px 0;
    grid-template-columns: 1fr;
  }
  .portfolio .studio-hero-art {
    min-height: 230px;
    border-radius: 130px 130px 4px 4px;
    margin-top: 15px;
  }
  .portfolio .studio-art-star {
    font-size: 115px;
  }
  .portfolio .studio-hero-art:before,
  .portfolio .studio-hero-art:after {
    width: 175px;
    height: 175px;
  }
  .portfolio .studio-art-caption {
    bottom: 15px;
  }
  .portfolio .studio-book {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  .portfolio .studio-book-art {
    min-height: 290px;
  }
  .portfolio .studio-project-grid,
  .portfolio .studio-two-column,
  .portfolio .studio-gallery,
  .portfolio .studio-editor-fields {
    grid-template-columns: 1fr;
  }
  .portfolio .studio-intro {
    padding-top: 50px;
  }
  .portfolio .studio-footer {
    grid-template-columns: 1fr;
  }
  .portfolio .studio-footer-links {
    justify-content: start;
  }
  .portfolio .studio-section-heading {
    align-items: start;
    flex-direction: column;
  }
  .portfolio .studio-section {
    padding: 40px 0;
  }
  .portfolio .studio-project-image {
    height: 220px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .portfolio * {
    scroll-behavior: auto !important;
    animation: none !important;
    transition: none !important;
  }
}
.portfolio .studio-reader {
  width: min(760px, 90%);
  margin: 0 auto;
  padding: 35px 0 70px;
}
.portfolio .studio-reader-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  font-size: 12px;
}
.portfolio .studio-reader-toolbar button {
  color: var(--studio-pink);
  background: var(--studio-panel);
}
.portfolio .studio-reader .studio-intro h1 {
  font-size: clamp(32px, 4vw, 50px);
}
.portfolio .studio-reading-text {
  font-family: Georgia, serif;
  font-size: 20px;
  line-height: 1.9;
  overflow-wrap: anywhere;
  color: #e6dfe6;
}
.portfolio .studio-reading-text.is-large {
  font-size: 24px;
}
.portfolio .studio-reading-text p,
.portfolio .studio-reading-text span {
  font-size: inherit !important;
  line-height: inherit !important;
  color: inherit !important;
}
.portfolio .studio-reading-text p {
  margin-bottom: 1.5em;
}
.portfolio .studio-reading-text img {
  max-width: 100%;
  height: auto;
}
.portfolio .studio-reading-text a {
  color: var(--studio-pink) !important;
  text-decoration: underline;
}
.portfolio .studio-chapter-nav {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  border-top: 1px solid var(--studio-line);
  padding-top: 30px;
  margin-top: 45px;
}
.portfolio .studio-chapter-nav a {
  max-width: 50%;
  text-align: center;
}
.portfolio .studio-story-heading {
  display: flex;
  align-items: start;
  gap: 30px;
  margin: 35px 0;
}
.portfolio .studio-story-heading h1 {
  font-size: clamp(30px, 4vw, 48px);
}
@media (max-width: 600px) {
  .portfolio .studio-story-heading {
    flex-direction: column;
  }
  .portfolio .studio-reader-toolbar {
    align-items: start;
  }
  .portfolio .studio-reader-toolbar button {
    font-size: 11px;
  }
  .portfolio .studio-reading-text {
    font-size: 18px;
  }
  .portfolio .studio-reader .studio-intro {
    padding-top: 35px;
  }
  .portfolio .studio-chapter-nav .studio-button {
    padding: 12px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/portfolio.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,yCAAyC;EACzC,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;;;;EAIE,aAAa;AACf;AACA;;;EAGE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;EAClC;0EACwE;AAC1E;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,2CAA2C;AAC7C;AACA;EACE,cAAc;AAChB;AACA;EACE,qDAAqD;EACrD,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,sBAAmB;KAAnB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAmB;KAAnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;;;EAGE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,sBAAmB;KAAnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,wCAAwC;EACxC,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,oCAAoC;IACpC,eAAe;EACjB;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,MAAM;IACN,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,kCAAkC;IAClC,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,YAAY;IACZ,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;;;;IAIE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,gCAAgC;IAChC,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":[".portfolio {\n  --studio-bg: #100e13;\n  --studio-panel: #19161d;\n  --studio-line: #343039;\n  --studio-muted: #b6adb9;\n  --studio-pink: #efa2ca;\n  --studio-violet: #bca9e8;\n  background: var(--studio-bg);\n  color: #f4eef3;\n  min-height: 100vh;\n  font-family: Inter, system-ui, sans-serif;\n  line-height: 1.65;\n}\n.portfolio * {\n  box-sizing: border-box;\n}\n.portfolio a {\n  color: inherit;\n  text-decoration: none;\n}\n.portfolio a:hover {\n  color: var(--studio-pink);\n}\n.portfolio :focus-visible {\n  outline: 2px solid var(--studio-pink);\n  outline-offset: 5px;\n}\n.portfolio h1,\n.portfolio h2,\n.portfolio h3,\n.portfolio p {\n  margin-top: 0;\n}\n.portfolio h1,\n.portfolio h2,\n.portfolio h3 {\n  line-height: 1.1;\n  letter-spacing: -0.04em;\n}\n.portfolio p {\n  color: var(--studio-muted);\n}\n.portfolio button {\n  font: inherit;\n  cursor: pointer;\n}\n.portfolio button:disabled {\n  opacity: 0.5;\n  cursor: wait;\n}\n.portfolio .studio-header {\n  min-height: 108px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 30px;\n  padding: 24px 4.5%;\n  border-bottom: 1px solid var(--studio-line);\n  position: relative;\n  z-index: 60;\n  background: var(--studio-bg);\n}\n.portfolio .studio-brand {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  font-size: 19px;\n  line-height: 1.2;\n}\n.portfolio .studio-mark {\n  font: italic 44px Georgia;\n  color: var(--studio-pink);\n  letter-spacing: -0.1em;\n  padding-right: 7px;\n}\n.portfolio .studio-brand-sub {\n  display: block;\n  font-size: 8px;\n  letter-spacing: 0.16em;\n  color: var(--studio-muted);\n  margin-top: 6px;\n}\n.portfolio .studio-nav {\n  display: flex;\n  gap: 25px;\n  align-items: center;\n  font-size: 13px;\n}\n.portfolio .studio-nav a {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.portfolio .studio-nav a.active {\n  color: var(--studio-pink);\n}\n.portfolio .studio-nav a.active:after {\n  content: \"\";\n  position: absolute;\n  bottom: 1px;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: var(--studio-pink);\n}\n.portfolio .studio-menu {\n  display: none;\n}\n.portfolio .studio-container {\n  width: min(1240px, 91%);\n  margin: auto;\n}\n.portfolio .studio-skip {\n  position: absolute;\n  top: -100px;\n  left: 20px;\n  background: #100e13;\n  padding: 12px;\n  z-index: 100;\n}\n.portfolio .studio-skip:focus {\n  top: 8px;\n}\n.portfolio .studio-eyebrow {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  font-weight: 600;\n  color: var(--studio-pink);\n  margin-bottom: 24px;\n}\n.portfolio .studio-eyebrow span {\n  color: #706575;\n  margin: 0 8px;\n}\n.portfolio .studio-hero {\n  padding: 96px 0 80px;\n  position: relative;\n  display: grid;\n  grid-template-columns: 1.5fr 1fr;\n  gap: 55px;\n  align-items: center;\n}\n.portfolio .studio-hero h1 {\n  font-size: clamp(48px, 6.4vw, 92px);\n  font-weight: 400;\n  max-width: 850px;\n  margin-bottom: 28px;\n}\n.portfolio .studio-hero h1 em {\n  font-family: Georgia, serif;\n  font-weight: 400;\n  color: var(--studio-pink);\n}\n.portfolio .studio-hero-copy {\n  font-size: 17px;\n  max-width: 490px;\n}\n.portfolio .studio-actions {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 32px;\n}\n.portfolio .studio-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 13px 24px;\n  background: var(--studio-pink);\n  color: #211220;\n  border: 1px solid var(--studio-pink);\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 3px;\n}\n.portfolio .studio-button:hover {\n  background: #f7c2df;\n  color: #211220;\n}\n.portfolio .studio-button.secondary {\n  color: #eee3ef;\n  background: transparent;\n  border-color: #514553;\n}\n.portfolio .studio-hero-art {\n  position: relative;\n  min-height: 370px;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  border: 1px solid var(--studio-line);\n  border-radius: 180px 180px 4px 4px;\n  background:\n    radial-gradient(ellipse at 50% 35%, #56334f, transparent 65%), #17131c;\n}\n.portfolio .studio-hero-art:before,\n.portfolio .studio-hero-art:after {\n  content: \"\";\n  position: absolute;\n  border: 1px solid #97728b;\n  border-radius: 50%;\n  width: 245px;\n  height: 245px;\n  transform: rotate(-35deg) scaleX(0.6);\n}\n.portfolio .studio-hero-art:after {\n  transform: rotate(35deg) scaleX(0.6);\n  border-color: #bca9e8;\n}\n.portfolio .studio-art-star {\n  font-size: 160px;\n  color: #e3bdce;\n  font-family: Georgia;\n  line-height: 1;\n  z-index: 1;\n}\n.portfolio .studio-art-caption {\n  position: absolute;\n  bottom: 28px;\n  text-transform: uppercase;\n  font-size: 9px;\n  letter-spacing: 0.25em;\n  color: #c6b6c9;\n}\n.portfolio .studio-section {\n  padding: 58px 0 66px;\n  border-top: 1px solid var(--studio-line);\n}\n.portfolio .studio-section-heading {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n.portfolio .studio-section-heading h2 {\n  font-size: clamp(28px, 3vw, 42px);\n  font-weight: 400;\n  margin: 0;\n}\n.portfolio .studio-text-link {\n  display: inline-flex;\n  align-items: center;\n  min-height: 44px;\n  font-size: 13px;\n  color: var(--studio-pink);\n  border-bottom: 1px solid #725469;\n}\n.portfolio .studio-intro {\n  padding: 76px 0 54px;\n  border-bottom: 1px solid var(--studio-line);\n  margin-bottom: 40px;\n}\n.portfolio .studio-intro h1 {\n  font-size: clamp(38px, 5vw, 70px);\n  font-weight: 400;\n  max-width: 900px;\n  margin-bottom: 22px;\n}\n.portfolio .studio-lede {\n  max-width: 650px;\n  font-size: 18px;\n}\n.portfolio .studio-books {\n  padding-bottom: 70px;\n}\n.portfolio .studio-book {\n  display: grid;\n  grid-template-columns: 1fr 1.4fr;\n  gap: 55px;\n  align-items: center;\n  padding: 42px 0;\n  border-bottom: 1px solid var(--studio-line);\n}\n.portfolio .studio-book:first-child {\n  padding-top: 0;\n}\n.portfolio .studio-book-art {\n  background: linear-gradient(140deg, #2a202c, #18161f);\n  min-height: 350px;\n  padding: 30px;\n  display: grid;\n  place-items: center;\n}\n.portfolio .studio-book-art img {\n  height: 320px;\n  width: auto;\n  max-width: 100%;\n  object-fit: contain;\n  box-shadow: 12px 15px 30px #0007;\n}\n.portfolio .studio-type-cover {\n  min-height: 300px;\n  width: min(230px, 100%);\n  padding: 30px 25px;\n  background: #e9daca;\n  color: #30242e;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border-left: 6px solid #c8b19e;\n  box-shadow: 12px 15px 30px #0007;\n}\n.portfolio .studio-type-cover strong {\n  font: 40px/1.05 Georgia;\n  letter-spacing: -0.05em;\n}\n.portfolio .studio-type-cover span {\n  font-size: 8px;\n  letter-spacing: 0.14em;\n}\n.portfolio .studio-book-copy h2 {\n  font-size: clamp(30px, 3.4vw, 45px);\n  font-weight: 400;\n}\n.portfolio .studio-author {\n  font-size: 12px;\n}\n.portfolio .studio-reader-link {\n  display: block;\n  font-size: 12px;\n  margin-top: 18px;\n  color: var(--studio-muted);\n}\n.portfolio .studio-project-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 28px;\n  padding-bottom: 50px;\n}\n.portfolio .studio-project-card {\n  background: var(--studio-panel);\n  border: 1px solid var(--studio-line);\n  overflow: hidden;\n  border-radius: 5px;\n}\n.portfolio .studio-project-image {\n  height: 250px;\n  width: 100%;\n  object-fit: contain;\n  background: #211d27;\n  padding: 20px;\n}\n.portfolio .studio-project-placeholder {\n  height: 200px;\n  display: grid;\n  place-items: center;\n  background: linear-gradient(140deg, #2f263a, #1b1920);\n  color: var(--studio-violet);\n  font-size: 55px;\n  font-family: Georgia;\n}\n.portfolio .studio-project-copy {\n  padding: 28px;\n}\n.portfolio .studio-project-copy h2 {\n  font-size: 29px;\n  margin: 15px 0;\n}\n.portfolio .studio-project-copy p {\n  font-size: 14px;\n}\n.portfolio .studio-badge {\n  display: inline-block;\n  font-size: 10px;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--studio-violet);\n  border: 1px solid #655373;\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n.portfolio .studio-meta {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  align-items: center;\n  font-size: 12px;\n  color: var(--studio-muted);\n}\n.portfolio .studio-filter {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin: 30px 0;\n}\n.portfolio label {\n  font-size: 13px;\n  display: block;\n}\n.portfolio input,\n.portfolio select,\n.portfolio textarea {\n  background: #211b27;\n  color: #f4eef3;\n  border: 1px solid #65556c;\n  border-radius: 4px;\n  padding: 10px;\n  max-width: 100%;\n}\n.portfolio .studio-filter select {\n  display: block;\n  min-width: 180px;\n  margin-top: 8px;\n}\n.portfolio .studio-editor-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n.portfolio .studio-editor-fields input,\n.portfolio .studio-editor-fields select,\n.portfolio .studio-editor-fields textarea {\n  display: block;\n  width: 100%;\n  margin-top: 7px;\n}\n.portfolio .studio-field-wide {\n  grid-column: 1/-1;\n}\n.portfolio .studio-rich-content {\n  max-width: 850px;\n  margin: 40px auto 70px;\n  overflow-wrap: anywhere;\n}\n.portfolio .studio-rich-content h2 {\n  font-size: 28px;\n  line-height: 1.3;\n}\n.portfolio .studio-rich-content p {\n  margin-bottom: 1.5em;\n}\n.portfolio .studio-rich-content a {\n  text-decoration: underline;\n  color: var(--studio-pink);\n}\n.portfolio .studio-gallery {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 24px;\n  margin: 30px 0;\n}\n.portfolio .studio-gallery img {\n  max-height: 450px;\n  object-fit: contain;\n}\n.portfolio .studio-update {\n  padding: 25px 0;\n  border-top: 1px solid var(--studio-line);\n}\n.portfolio .studio-two-column {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 45px;\n}\n.portfolio .studio-note {\n  padding: 35px;\n  background: var(--studio-panel);\n  border: 1px solid var(--studio-line);\n}\n.portfolio .studio-note h2 {\n  font-size: 30px;\n  font-weight: 400;\n}\n.portfolio .studio-writing-link {\n  display: flex;\n  justify-content: space-between;\n  gap: 25px;\n  padding: 34px 0;\n  border-bottom: 1px solid var(--studio-line);\n}\n.portfolio .studio-writing-link h2 {\n  font-size: 36px;\n  font-weight: 400;\n  margin-bottom: 12px;\n}\n.portfolio .studio-writing-link span {\n  font-size: 28px;\n  color: var(--studio-pink);\n}\n.portfolio .studio-footer {\n  padding: 65px 4.5% 25px;\n  border-top: 1px solid var(--studio-line);\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n}\n.portfolio .studio-footer-brand {\n  display: flex;\n  gap: 30px;\n  font-size: 30px;\n  letter-spacing: -0.04em;\n  align-items: center;\n}\n.portfolio .studio-footer-brand span {\n  color: var(--studio-pink);\n}\n.portfolio .studio-footer p {\n  font-size: 12px;\n}\n.portfolio .studio-footer-links {\n  display: flex;\n  gap: 20px;\n  align-items: start;\n  justify-content: end;\n  flex-wrap: wrap;\n  font-size: 12px;\n}\n.portfolio .studio-colophon {\n  grid-column: 1/-1;\n  display: flex;\n  justify-content: space-between;\n  font-size: 10px;\n  color: #9b909f;\n  border-top: 1px solid var(--studio-line);\n  padding-top: 25px;\n}\n.portfolio .studio-music {\n  padding-bottom: 70px;\n}\n.portfolio .studio-empty {\n  padding: 40px 0;\n}\n.portfolio .studio-music-embed {\n  border: 0;\n  border-radius: 8px;\n  width: 100%;\n  height: 352px;\n}\n@media (max-width: 1050px) {\n  .portfolio .studio-nav {\n    gap: 15px;\n    font-size: 12px;\n  }\n  .portfolio .studio-brand-sub {\n    display: none;\n  }\n  .portfolio .studio-hero {\n    gap: 25px;\n  }\n  .portfolio .studio-hero-art {\n    min-height: 320px;\n  }\n}\n@media (max-width: 800px) {\n  .portfolio .studio-header {\n    min-height: 85px;\n    flex-wrap: wrap;\n    padding: 20px 5%;\n  }\n  .portfolio .studio-menu {\n    display: block;\n    background: transparent;\n    color: var(--studio-pink);\n    border: 1px solid var(--studio-line);\n    font-size: 12px;\n  }\n  .portfolio .studio-nav {\n    display: none;\n    flex-basis: 100%;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0;\n    padding: 12px 0;\n  }\n  .portfolio .studio-nav.is-open {\n    display: flex;\n  }\n  .portfolio .studio-nav a {\n    padding: 10px 0;\n  }\n  .portfolio .studio-nav a.active:after {\n    display: none;\n  }\n  .portfolio .studio-hero {\n    padding: 58px 0;\n    grid-template-columns: 1fr;\n  }\n  .portfolio .studio-hero-art {\n    min-height: 230px;\n    border-radius: 130px 130px 4px 4px;\n    margin-top: 15px;\n  }\n  .portfolio .studio-art-star {\n    font-size: 115px;\n  }\n  .portfolio .studio-hero-art:before,\n  .portfolio .studio-hero-art:after {\n    width: 175px;\n    height: 175px;\n  }\n  .portfolio .studio-art-caption {\n    bottom: 15px;\n  }\n  .portfolio .studio-book {\n    grid-template-columns: 1fr;\n    gap: 25px;\n  }\n  .portfolio .studio-book-art {\n    min-height: 290px;\n  }\n  .portfolio .studio-project-grid,\n  .portfolio .studio-two-column,\n  .portfolio .studio-gallery,\n  .portfolio .studio-editor-fields {\n    grid-template-columns: 1fr;\n  }\n  .portfolio .studio-intro {\n    padding-top: 50px;\n  }\n  .portfolio .studio-footer {\n    grid-template-columns: 1fr;\n  }\n  .portfolio .studio-footer-links {\n    justify-content: start;\n  }\n  .portfolio .studio-section-heading {\n    align-items: start;\n    flex-direction: column;\n  }\n  .portfolio .studio-section {\n    padding: 40px 0;\n  }\n  .portfolio .studio-project-image {\n    height: 220px;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .portfolio * {\n    scroll-behavior: auto !important;\n    animation: none !important;\n    transition: none !important;\n  }\n}\n.portfolio .studio-reader {\n  width: min(760px, 90%);\n  margin: 0 auto;\n  padding: 35px 0 70px;\n}\n.portfolio .studio-reader-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  font-size: 12px;\n}\n.portfolio .studio-reader-toolbar button {\n  color: var(--studio-pink);\n  background: var(--studio-panel);\n}\n.portfolio .studio-reader .studio-intro h1 {\n  font-size: clamp(32px, 4vw, 50px);\n}\n.portfolio .studio-reading-text {\n  font-family: Georgia, serif;\n  font-size: 20px;\n  line-height: 1.9;\n  overflow-wrap: anywhere;\n  color: #e6dfe6;\n}\n.portfolio .studio-reading-text.is-large {\n  font-size: 24px;\n}\n.portfolio .studio-reading-text p,\n.portfolio .studio-reading-text span {\n  font-size: inherit !important;\n  line-height: inherit !important;\n  color: inherit !important;\n}\n.portfolio .studio-reading-text p {\n  margin-bottom: 1.5em;\n}\n.portfolio .studio-reading-text img {\n  max-width: 100%;\n  height: auto;\n}\n.portfolio .studio-reading-text a {\n  color: var(--studio-pink) !important;\n  text-decoration: underline;\n}\n.portfolio .studio-chapter-nav {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  border-top: 1px solid var(--studio-line);\n  padding-top: 30px;\n  margin-top: 45px;\n}\n.portfolio .studio-chapter-nav a {\n  max-width: 50%;\n  text-align: center;\n}\n.portfolio .studio-story-heading {\n  display: flex;\n  align-items: start;\n  gap: 30px;\n  margin: 35px 0;\n}\n.portfolio .studio-story-heading h1 {\n  font-size: clamp(30px, 4vw, 48px);\n}\n@media (max-width: 600px) {\n  .portfolio .studio-story-heading {\n    flex-direction: column;\n  }\n  .portfolio .studio-reader-toolbar {\n    align-items: start;\n  }\n  .portfolio .studio-reader-toolbar button {\n    font-size: 11px;\n  }\n  .portfolio .studio-reading-text {\n    font-size: 18px;\n  }\n  .portfolio .studio-reader .studio-intro {\n    padding-top: 35px;\n  }\n  .portfolio .studio-chapter-nav .studio-button {\n    padding: 12px;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
